
const InvestmentContent = ({ marginSummery, totalnetAssetValue_AED, totalcashBalance_AED, totalMarketValue_AED }) => {
    const headerStyle = {
        backgroundColor: '#004080',
        color: '#fff',
        fontSize: '13px',
        fontFamily: 'Roboto Regular',
        fontWeight: "normal",
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        verticalAlign: 'middle',
        textAlign: "center",
        padding: "4px 5px"
    };

    const tdStyle = {
        background: '#e0e0e0',
        borderBottom: '1px solid #fff',
        borderRight: '1px solid rgb(255 255 255 / 50%)',
        padding: "4px 5px",
        color: "#000",
        fontSize: '13px',

    }
    const totalTd = {
        fontFamily: "Roboto Black",
        borderTop: '1px solid #000',
        borderBottom: '1px solid #000',
        // padding:"1px",
        fontSize: "13px"
    }
    const total = {
        fontFamily: "Roboto Black",
        fontSize: "13px"
    }
    const avoidPageBreak = {
        pageBreakInside: "avoid",
        breakInside: "avoid-column" // For browsers that support the modern "break-*"
    };
    return (
        <div className="row m-0">
            <div className="col-md-12 mx-auto">
                <div className=" ">
                    <table className="table">
                        <thead>
                            <tr>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Currency</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Market Value</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Cash Balance</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Total Blocked Amount (Margin/Loss)</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Available Cash</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Net Asset Value (NAV)</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>FX Rate (AED)</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Market Value (AED)</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Available Cash(AED)</th>
                                <th style={{ ...headerStyle, width: '10%', minWidth: '10px' }}>Net Asset Value (AED)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <>
                                {marginSummery?.map((item, index) => (

                                    <tr key={index}>
                                        <td style={{ ...tdStyle, fontSize: "12px" }}>{item?.transactionCurrency}</td>
                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.marketValue) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.marketValue) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.marketValue)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.marketValue) || 0)}
                                            </span>
                                        </td>

                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.cashBalance) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.cashBalance) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.cashBalance)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.cashBalance) || 0)}
                                            </span>
                                        </td>
                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.totalBlockedAmountMarginOrLoss) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.totalBlockedAmountMarginOrLoss) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.totalBlockedAmountMarginOrLoss)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.totalBlockedAmountMarginOrLoss) || 0)}
                                            </span>
                                        </td>
                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.availableCash) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.availableCash) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.availableCash)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.availableCash) || 0)}
                                            </span>
                                        </td>
                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.netAssetValue_NAV) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.netAssetValue_NAV) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.netAssetValue_NAV)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.netAssetValue_NAV) || 0)}
                                            </span>
                                        </td>
                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.fxRate) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.fxRate) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(item.fxRate)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(item.fxRate) || 0)}
                                            </span>
                                        </td>

                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.marketValue_AED) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.marketValue_AED) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.marketValue_AED)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.marketValue_AED) || 0)}
                                            </span>
                                        </td>
                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.availableCash_AED) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.availableCash_AED) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.availableCash_AED)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.availableCash_AED) || 0)}
                                            </span>
                                        </td>
                                        <td className="text-end" style={tdStyle}>
                                            <span style={{ color: Number(item.netAssetValue_AED) < 0 ? '#E43740' : 'black' }}>
                                                {Number(item.netAssetValue_AED) < 0
                                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(item.netAssetValue_AED)) || 0)})`
                                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(item.netAssetValue_AED) || 0)}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </>
                        </tbody>
                        <tfoot>
                            <tr>

                                <td className="bg-tr-td invisible-classes"></td>
                                <td className="bg-tr-td invisible-classes"></td>
                                <td className="bg-tr-td invisible-classes"></td>
                                <td className="bg-tr-td invisible-classes"></td>
                                <td className="bg-tr-td invisible-classes"></td>
                                <td className="bg-tr-td invisible-classes"></td>
                                <td className="tfoot-color bottom-left-radius invisible-classes">Total</td>
                                <td className="tfoot-color text-end  table-split-div">
                                    <span className="mobile-td-head">Market Value (AED)</span>
                                    {/* {totalMarketValue_AED} */}
                                    <span style={{ color: Number(totalMarketValue_AED) < 0 ? '#E43740' : 'black' }}>
                                        {Number(totalMarketValue_AED) < 0
                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(totalMarketValue_AED)) || 0)})`
                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(totalMarketValue_AED) || 0)}
                                    </span>
                                </td>
                                <td className="tfoot-color text-end  table-split-div">
                                    <span className="mobile-td-head">Transaction Currency</span>
                                    {/* {totalcashBalance_AED} */}
                                    <span style={{ color: Number(totalcashBalance_AED) < 0 ? '#E43740' : 'black' }}>
                                        {Number(totalcashBalance_AED) < 0
                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(totalcashBalance_AED)) || 0)})`
                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(totalcashBalance_AED) || 0)}
                                    </span>
                                </td>
                                <td className="tfoot-color text-end bottom-right-radius  table-split-div">
                                    <span className="mobile-td-head">Net Asset Value (AED)</span>
                                    {/* {totalnetAssetValue_AED} */}
                                    <span style={{ color: Number(totalnetAssetValue_AED) < 0 ? '#E43740' : 'black' }}>
                                        {Number(totalnetAssetValue_AED) < 0
                                            ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(totalnetAssetValue_AED)) || 0)})`
                                            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(totalnetAssetValue_AED) || 0)}
                                    </span>
                                </td>

                            </tr>
                        </tfoot>
                    </table>
                    {/* <table className="table">
                                    <thead>
                                        <tr>
                                            <th style={{...headerStyle, width: '50%' }}>Cash Balance</th>
                                            <th style={{...headerStyle, width: '50%' }}></th>
                                        </tr>
                                    </thead>
                                    <tbody>
    {cashBalanceDetails?.map((margin, index) => {
        const isLastMargin = index === cashBalanceDetails.length - 1;
        return Object.entries(margin).map(([key, value], idx, arr) => {
            const isLastRow = isLastMargin && idx === arr.length - 1;
            return (
                <tr key={`${index}-${idx}`}>
                    <td style={{ ...tdStyle, ...(isLastRow ? { backgroundColor: '#A09171' } : {}) }}>{key}</td>
                    <td
                        className="tfoot-color text-end table-split-div text-end"
                        style={{ ...tdStyle, ...(isLastRow ? { backgroundColor: '#A09171' } : {}) }}
                    >
                        {parseFloat(value).toLocaleString()}
                    </td>
                </tr>
            );
        });
    })}
</tbody>

                                </table> */}
                </div>
            </div>

        </div>)
}
export default InvestmentContent